import { ReactNode } from 'react';

export async function loadCartNavDropdownContent(): Promise<ReactNode> {
    const asyncChunk = await import(
        /* webpackChunkName: "CartNavDropdownContent" */
        './CartNavDropdownContent'
    );
    const { default: CartNavDropdownContent } = asyncChunk;
    return CartNavDropdownContent;
}
